import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

import type { RootState } from "@/store/types";

export function useSidebar() {
    const store = useStore<RootState>();
    const router = useRouter();

    const isSidebarOpen = computed<boolean>(() => store.state.ui.isSidebarOpen);
    const sidebarWidthOpen = computed<number>(() => store.state.ui.sidebarWidthOpen);
    const sidebarWidthCollapsed = computed<number>(() => store.state.ui.sidebarWidthCollapsed);

    const openSidebar = () => store.dispatch("ui/openSidebar");
    const closeSidebar = () => store.dispatch("ui/closeSidebar");

    const setSidebarWidthOpen = (width: number) => store.dispatch("ui/setSidebarWidthOpen", width);
    const setSidebarWidthCollapsed = (width: number) => store.dispatch("ui/setSidebarWidthCollapsed", width);

    // TODO - MOVE IT IN ROUTER AFTER MERGE
    router.beforeEach(async (to, from) => {
        if (to.name !== from.name) {
            await closeSidebar();
        }
    });

    return {
        isSidebarOpen,
        sidebarWidthOpen,
        sidebarWidthCollapsed,
        openSidebar,
        closeSidebar,
        setSidebarWidthOpen,
        setSidebarWidthCollapsed
    };
}
